//= Functions & Modules
// Others
import React from 'react';

type Props = React.HTMLProps<HTMLDivElement>;

export class Card extends React.PureComponent<Props> {
    render() {
        const { className, ...otherProps } = this.props;
        return (
            <div
                {...otherProps}
                className={`p-4 bg-panel rounded-xl shadow-sm ${className ? className : ''}`}
                style={{ border: '1px solid rgba(255,255,255,0.06)', ...(otherProps.style || {}) }}
            >
                {this.props.children}
            </div>
        );
    }
}
